<h2>{{ 'imageControl.delete' | translate }}</h2>
<h4>{{ 'imageControl.delete-warning' | translate }}</h4>
<section class="delete-buttons">
  <app-action-button type="cancel" (click)="onCancel()"> {{ 'imageControl.back' | translate }} </app-action-button>
  <app-action-button type="accept" variant="filled" (click)="onDelete()" [loading]="loading">
    {{ 'imageControl.confirm' | translate }}
  </app-action-button>
</section>
